import React from 'react';
import { makeStyles, createStyles } from '@material-ui/core/styles';

type GroupBoxProps = {
  name: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
};

const useStyles = makeStyles(
  createStyles({
    box: {
      display: 'flex',
      borderStyle: 'solid',
      borderWidth: 'thin',
      borderColor: 'gray',
      borderRadius: '4px',
      alignItems: 'center',
      padding: '0px',
      height: '36px',
    },
    header: {
      color: 'white',
      fontWeight: 'bold',
      background: 'gray',
      padding: '4px 8px',
      height: '30px',
      borderRadius: '4px 0px 0px 4px',
    },
    body: {
      padding: '2px 8px',
      margin: '0px',
    },
  })
);

const GroupBox: React.FC<GroupBoxProps> = (props: GroupBoxProps) => {
  const classes = useStyles();

  return (
    <div className={classes.box} style={props.style}>
      <div className={classes.header}>{props.name}</div>
      <div className={classes.body}>{props.children}</div>
    </div>
  );
};

export default GroupBox;
